// extracted by mini-css-extract-plugin
module.exports = {"filmCard":"style_filmCard__3pcSQ","overlay":"style_overlay___vtZ6","image":"style_image__pNkVV","logo":"style_logo__2M3G7"};